export default __webpack_public_path__ + "static/media/pencils.abbdadcc.svg";